import React from 'react'
import type { PaginationPageSizeSelectProps } from './pagination.types'
import { defaultTranslate } from './pagination.default'
import { generateUUID } from '@/modules/shared/utils/id'

export const PaginationPageSizeSelect: React.FC<PaginationPageSizeSelectProps> = ({
  value,
  options,
  disabled = false,
  onChange,
  t = defaultTranslate,
}) => {
  const selectId = generateUUID()

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(parseInt(e.target.value, 10))
  }

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <label
        htmlFor={selectId}
        className="tw-m-0 tw-text-sm tw-font-medium tw-text-content-base"
      >
        {t("ui.pagination.sizelabel")}:
      </label>

      <select
        id={selectId}
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className="tw-rounded-md tw-border tw-border-content-base tw-border-opacity-20 tw-bg-white tw-px-3 tw-py-1.5 tw-text-sm tw-font-medium tw-text-content-base tw-transition-all hover:tw-border-opacity-40 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-focus-100 focus:tw-ring-offset-1 disabled:tw-cursor-not-allowed disabled:tw-opacity-50"
      >
        {options.map((option) => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>
    </div>
  )
}
